import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "../../../styles/pages/profile/ProfilePage.module.css";

const MatchesViewSkeleton = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionHeader}>
        <div>
          <Skeleton
            height={32}
            width="200px"
            style={{ marginBottom: "10px" }}
          />
          <Skeleton height={18} width="150px" />
        </div>
        <Skeleton height={40} width={100} borderRadius={8} />
      </div>
      <div className={styles.listsGrid}>
        {[1, 2, 3].map((i) => (
          <div key={i} className={styles.listCard}>
            <Skeleton
              height={24}
              width="80%"
              style={{ marginBottom: "10px" }}
            />
            <Skeleton
              height={16}
              width="60%"
              style={{ marginBottom: "15px" }}
            />
            <div style={{ display: "flex", gap: "5px", marginBottom: "15px" }}>
              <Skeleton height={60} width="60px" />
              <Skeleton height={60} width="60px" />
              <Skeleton height={60} width="60px" />
              <Skeleton height={60} width="60px" />
            </div>
            <div style={{ display: "flex", gap: "15px" }}>
              <Skeleton height={16} width={80} />
              <Skeleton height={16} width={80} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MatchesViewSkeleton;
